import Entity from './entity'
export default class Category extends Entity<number>{
    name:string;
    simpleCategoryName:string;
    description:string;
    imageUrl:string;
    imageId:number;

    constructor() {
    	super();
        this.imageUrl= "";
        this.imageId=0;
  	}
}